import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-info',
  standalone: true,
    imports: [
        NgOptimizedImage
    ],
  templateUrl: './info.component.html',
  // styleUrl: './info.component.css'
})
export class InfoComponent {

}
